import { render, staticRenderFns } from "./ListadoPrincipalPedidos.vue?vue&type=template&id=a732360e&scoped=true"
import script from "./ListadoPrincipalPedidos.vue?vue&type=script&lang=js"
export * from "./ListadoPrincipalPedidos.vue?vue&type=script&lang=js"
import style0 from "./ListadoPrincipalPedidos.vue?vue&type=style&index=0&id=a732360e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a732360e",
  null
  
)

export default component.exports